/**
 * Static page and quick-action entries for the command palette
 * (`useUniversalSearch`). Kept apart from the hook, and free of `@/` imports,
 * so the assist anchor registry (`src/features/assist`) can seed its `nav.*`
 * anchors from the same list and the Node manifest build can load it.
 */

import {
  IMPORT_SPREADSHEET_PATH,
  PALETTE_IMPORT_DESCRIPTION,
  PALETTE_IMPORT_NAME,
} from '../components/csv-import/importCopy.js'

/** Main navigation pages. */
export const NAV_SEARCH_ITEMS = [
  { id: 'nav-dashboards', name: 'Dashboards', path: '/dashboards', type: 'Navigation', icon: 'LayoutDashboard' },
  { id: 'nav-data-entry', name: 'Data entry', path: '/data-entry', type: 'Navigation', icon: 'ClipboardList' },
  { id: 'nav-metrics', name: 'Metrics', path: '/metrics', type: 'Navigation', icon: 'BarChart3' },
  { id: 'nav-categories', name: 'Categories', path: '/categories', type: 'Navigation', icon: 'Layers' },
  { id: 'nav-partitions', name: 'Partition types', path: '/partitions', type: 'Navigation', icon: 'Boxes' },
  { id: 'nav-reports', name: 'Reports', path: '/reports', type: 'Navigation', icon: 'FileText' },
  { id: 'nav-report-templates', name: 'PDF templates', path: '/report-templates', type: 'Navigation', icon: 'Files' },
  { id: 'nav-getting-started', name: 'Getting started', path: '/getting-started', type: 'Navigation', icon: 'Compass' },
]

/** Quick actions shown under "Actions". */
export const ACTION_SEARCH_ITEMS = [
  { id: 'action-new-metric', name: 'Create metric', path: '/metrics?create=true', type: 'Actions', icon: 'Plus', access: 'manage' },
  { id: 'action-new-report', name: 'Create report', path: '/reports/new', type: 'Actions', icon: 'Plus' },
  { id: 'action-import-spreadsheet', name: PALETTE_IMPORT_NAME, path: IMPORT_SPREADSHEET_PATH, type: 'Actions', icon: 'FileUp', description: PALETTE_IMPORT_DESCRIPTION, access: 'edit' },
]
